module.exports = __webpack_public_path__ + "static/media/openlayers.637a0af4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/openlayers.svg
// module id = 65
// module chunks = 0